import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=4be7111c&"
import script from "./PedidosTable.vue?vue&type=script&lang=js&"
export * from "./PedidosTable.vue?vue&type=script&lang=js&"
import style0 from "./PedidosTable.vue?vue&type=style&index=0&id=4be7111c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports